import { Box, Icon } from '@jfs/ui-new'
import { FC } from 'react';

interface ShowHidePasswordProps {
  hide?: boolean
  isDisabled?: boolean
  isPasswordVisible: (data: boolean) => void
  showPassword: boolean
}

const ShowHidePassword: FC<ShowHidePasswordProps> = ({
  hide,
  isDisabled,
  isPasswordVisible,
  showPassword,
}: ShowHidePasswordProps) => {
  if (hide) {
    return null
  }
  const onPress = () => {
    isPasswordVisible(!showPassword)
  }
  return (
    <Box disabled={isDisabled} onPress={onPress}>
      <Box underlayColor="WHITE">
        <Icon id={showPassword ? 'EYE_WATCH' : 'EYE_WATCH_SELECTED'} color="PRIMARY" size="FONT_SIZE_LARGE" />
      </Box>
    </Box>
  )
}
export default ShowHidePassword
